module.exports = __webpack_public_path__ + "img/relax.b9fffae0.png";